"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
const api_response_error_1 = require("../errors/api/api-response-error");
/**
 * Represents an API response object
 *
 * *Usage*
 *
 * ```ts
 * const response = Response<DataReturned>();
 * const responseBody = response.body;
 * const dataReturned = responseBody.data;
 * ```
 */
class Response {
    /**
     * Accepts string or JS object
     *
     * @param resContent
     */
    constructor(resContent) {
        this.body = null;
        const type = typeof resContent;
        if (type === "object") {
            // Type will be an object if Ajax is configured to use JSON as the default parser
            this.body = resContent;
        }
        else if (type === "string") {
            // Type will be a JSON string if Ajax cannot auto resolve the content type
            try {
                this.body = JSON.parse(resContent);
            }
            catch (e) {
                throw new api_response_error_1.ApiResponseError("Cannot parse response json: " + e);
            }
        }
        else {
            throw new api_response_error_1.ApiResponseError("Response not recognized by Ex-Online");
        }
    }
    //#region getter
    /**
     * Did the server declare the result as valid
     */
    isSuccessful() {
        return this.getStatus() === "success";
    }
    /**
     * Gets the request status
     */
    getStatus() {
        return this.body.status;
    }
    /**
     * Gets the description message of the request
     */
    getMessage() {
        return this.body.message;
    }
    /**
     * Gets the time the request was generated
     */
    getTimestamp() {
        return this.body.timestamp;
    }
    /**
     * Gets the errors incurred in the request
     */
    getError() {
        return this.body.err;
    }
    //#endregion
    /**
     * Converts the result to a JSON string
     */
    toString() {
        return JSON.stringify(this.body);
    }
}
exports.Response = Response;
//# sourceMappingURL=response.js.map